import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthButton({ intendedRole, testid = "google-auth-button", label = "Continue with Google" }) {
  const onClick = () => {
    if (intendedRole) localStorage.setItem("mm_google_role", intendedRole);
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="w-full h-11 rounded-lg bg-white text-black font-semibold flex items-center justify-center gap-2 hover:bg-zinc-100 active:scale-[0.98] transition-transform border border-white/10"
    >
      <GoogleLogo size={18} weight="bold" />
      {label}
    </button>
  );
}
